module.exports = __webpack_public_path__ + "img/whisper-tit.265aaba5.png";